(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/coupon/alternatives.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/coupon/alternatives.js');
"use strict";


const ButtonBet = svs.components.ReactButtonBet;
class Alternatives extends React.Component {
  constructor(props) {
    super(props);
    this.alternativeClick = this.alternativeClick.bind(this);
  }
  renderAlternative(alternative, index) {
    const {
      eventNumber
    } = this.props;
    return React.createElement(ButtonBet, {
      autotestId: "r_".concat(eventNumber, "_o_").concat(alternative.outcomeNumber),
      className: "btn-bet-challenge",
      disabled: alternative.description === '',
      key: index,
      label: alternative.description,
      labelStyle: alternative.description.length >= 4 ? {
        padding: '0 4px'
      } : {},
      onClick: _.partial(this.alternativeClick, alternative),
      selected: this.isSelected(alternative.outcomeNumber)
    });
  }
  alternativeClick(alternative, event) {
    const {
      selectItemAction,
      draw,
      eventNumber
    } = this.props;
    event.stopPropagation();
    selectItemAction(draw.drawNumber, eventNumber, alternative.outcomeNumber);
  }
  isSelected(outcomeNumber) {
    const {
      coupon,
      eventNumber
    } = this.props;
    let selected = false;
    if (coupon.drawEvents && coupon.drawEvents[eventNumber]) {
      selected = coupon.drawEvents[eventNumber][outcomeNumber];
    }
    return Boolean(selected);
  }
  render() {
    const {
      alternatives
    } = this.props;
    const mappedAlternatives = alternatives.map((alternative, index) => this.renderAlternative(alternative, index));
    return React.createElement("div", {
      className: "simple-row right js-clickable-ignore js-outcomes"
    }, mappedAlternatives);
  }
}
svs.challenge.Alternatives = Alternatives;

 })(window);